import {BBModel} from "../bb_model";
import {ClinicCollections} from "../collections/clinic_collections";
import {Collection} from "../collections/base";

const adminClinic = {
    query(params) {
        const {company} = params;
        return new Promise((resolve, reject) => {
            if (params.id) { // reuqest for a single one
                company.$get('clinics', params).then((clinic) => {
                        clinic = new BBModel.Admin.Clinic(clinic);
                        return resolve(clinic);
                    }
                    , err => reject(err));
            } else {
                const existing = ClinicCollections.find(params);
                if (existing && !params.skip_cache) {
                    resolve(existing);
                } else {
                    if (params.skip_cache) {
                        if (existing) {
                            ClinicCollections.delete(existing);
                        }
                        company.$flush('clinics', params);
                    }
                    company.$get('clinics', params).then(collection =>
                            collection.$get('clinics').then((clinics) => {
                                    const models = (Array.from(clinics).map(s => new BBModel.Admin.Clinic(s)));
                                    clinics = new Collection.Clinic(collection, models, params);
                                    ClinicCollections.add(clinics);
                                    return resolve(clinics);
                                }
                                , err => reject(err))

                        , err => reject(err));
                }
            }
        });
    },

    create(prms, clinic) {
        const {company} = prms;
        return new Promise((resolve, reject) => {
            company.$post('clinics', {}, clinic.getPostData()).then((clinic) => {
                    clinic = new BBModel.Admin.Clinic(clinic);
                    ClinicCollections.checkItems(clinic);
                    return resolve(clinic);
                }
                , (err) => {
                    return reject(err);
                }
            );
        });
    },

    cancel(clinic) {
        return new Promise((resolve, reject) => {
            clinic.$post('cancel', clinic).then((clinic) => {
                    clinic = new BBModel.Admin.Clinic(clinic);
                    ClinicCollections.deleteItems(clinic);
                    return resolve(clinic);
                }
                , (err) => {
                    return reject(err);
                }
            );
        });
    },

    update(clinic) {
        return new Promise((resolve, reject) => {
            clinic.$put('self', {}, clinic.getPostData()).then((c) => {
                    clinic = new BBModel.Admin.Clinic(c);
                    ClinicCollections.checkItems(clinic);
                    return resolve(clinic);
                }
                , (err) => {
                    return reject(err);
                }
            );
        });
    }
};

export {
    adminClinic
}